<template>
  <Modal name="ticketHistory" v-bind="$attrs" :key='ticketId'
         size="w-screen h-screen md:h-auto md:max-w-3xl md:w-6/12 md:rounded-3xl">
    <template v-slot:header>
      <div v-if="ticket" class="ticket-number">
        <h1>#{{ ticket.CaseNumber }}</h1>
      </div>
    </template>
    <template v-slot:body>
      <div v-if="!ticket && ticket !== false">
        <loader></loader>
      </div>
      <div v-else-if="ticket === false">
        {{ $t('something_went_wrong') }}
      </div>
      <div v-else>
        <div class="grid grid-cols-1 sm:grid-cols-1 sm:gap-x-8">
          <main class="ticket">
            <header>
              <div class="status-bar">
                <div class="status">
                  {{ getT(ticket.Status) }}
                </div>
              </div>
            </header>
            <div class="ticket-data">
              <template v-for="(ticketData, key) in mapNested(ticket)">
                <div v-bind:key="key" v-if="!isExcluded(key) && ticketData !== null" class="alternating text-sm">
                  <div class="font-semibold margin-right">{{ getT(key) }}</div>
                  <div>{{ Vue.unifyDateFormat(ticketData) }}</div>
                </div>
              </template>
            </div>
          </main>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="btn btn-primary submit" @click="$attrs.close()">
        {{ $t('close') }}
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '../modules/modals/components/Modal'
import {mapActions, mapGetters} from "vuex";
import Loader from "@/components/Loader.vue";
import Vue from "vue";

export default {
  name: 'modalChangeReport',
  components: {
    Loader,
    Modal
  },
  computed: {
    Vue() {
      return Vue
    },
    ...mapGetters([
      'ticket'
    ])
  },
  methods: {
    ...mapActions([
      'downloadTicket'
    ]),
    isExcluded(name) {
      return ['AssetId', 'Id', 'SiteName__c', 'attributes', 'Custom_Attribute__c', 'CaseNumber', 'CreatedById'].includes(name)
    },
    mapNested(ticket) {
      Object.keys(ticket).forEach(function(key) {
        if (ticket[key] === null || ticket[key]['Name'] === undefined) return;
        ticket[key] = ticket[key]['Name']
      })
      return ticket
    },
    getT(name) {
      const key = name.toLowerCase().replace(/ /g, '_').replace('(', '').replace(')', '')
      const translation = this.$t(key)

      if (translation === key) {
        return name
      }
      return translation
    }
  },
  mounted() {
    this.downloadTicket({assetId: this.$attrs.assetId, ticketId: this.$attrs.ticketId})
  }
}
</script>

<style lang="sass" scoped>
h1
  font-size: 25px !important

.margin-right
  margin-right: 0.25em

.ticket
  text-transform: uppercase

  .status-bar
    text-align: center
    font-weight: bold
    @apply bg-sparkYellow
    margin-bottom: 1rem

.ticket-number
  text-transform: uppercase

  h1
    text-align: center
    font-weight: bold
    margin: 0

.alternating
  display: flex

  &:nth-child(even)
    @apply bg-gray-100

.ticket-data
  column-count: 2
</style>